import { render, staticRenderFns } from "./FormPlace.vue?vue&type=template&id=ebfde70a&scoped=true&"
import script from "./FormPlace.vue?vue&type=script&lang=js&"
export * from "./FormPlace.vue?vue&type=script&lang=js&"
import style0 from "./FormPlace.vue?vue&type=style&index=0&id=ebfde70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfde70a",
  null
  
)

export default component.exports